import { render } from "./CustomizeEmail.vue?vue&type=template&id=1fe74c45&ts=true"
import script from "./CustomizeEmail.vue?vue&type=script&lang=ts"
export * from "./CustomizeEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__